export default __webpack_public_path__ + "static/media/time-gray.bba61303.svg";